import './lib/log';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { registerSW } from './pwa/sw-register';
import {
  backfillChatTitles,
  recoverChatsFromIdb,
  startChatMetaMirror,
} from './lib/chatRecovery';
import { maybeAutoBootstrap } from './lib/bootstrap';
import { installInFlightRecoveryHooks } from './lib/inflightRecovery';
import { syncTokenWithCookie } from './lib/authToken';
import { startPushSync } from './lib/pushSync';

registerSW();
syncTokenWithCookie();
startChatMetaMirror();
startPushSync();
void recoverChatsFromIdb()
  .catch((e) => console.warn('chat recovery failed', e))
  .then(() => backfillChatTitles())
  .catch((e) => console.warn('chat title backfill failed', e));
void maybeAutoBootstrap().finally(() => installInFlightRecoveryHooks());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
